import api from '../..'

export const NORMATIVE_INCOMPLETE_PARTICIPANTS_REPORT_FILENAME =
  'Participantes con información incompleta para DC-3.xlsx'

const downloadNormativeIncompleteParticipantsReport = async (
  courseId: number,
  source?: 'monitoring'
) => {
  const { data } = await api.get<Blob>(
    `administration/courses/${courseId}/normative_incomplete_participants_report`,
    { responseType: 'blob', params: { source } }
  )

  return {
    blob: data,
    filename: NORMATIVE_INCOMPLETE_PARTICIPANTS_REPORT_FILENAME,
  }
}

export default downloadNormativeIncompleteParticipantsReport
